<app-header (hideCarouselEvent)="hideCarousel() "></app-header>
<app-grid #grid></app-grid>